import { render, staticRenderFns } from "./TribesUsers.vue?vue&type=template&id=dac3e784&scoped=true&"
import script from "./TribesUsers.vue?vue&type=script&lang=js&"
export * from "./TribesUsers.vue?vue&type=script&lang=js&"
import style0 from "./TribesUsers.vue?vue&type=style&index=0&id=dac3e784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac3e784",
  null
  
)

export default component.exports